export default __webpack_public_path__ + "static/media/DP3 2A-1EC.b5fb53af.jpg";